import { parse } from 'qs'

export const getQueryParams = query => {
  const index = query.indexOf('#')
  if (index > 0) {
    query = query.substring(0, index)
  }
  return parse(query, { ignoreQueryPrefix: true, format: 'RFC1738' })
}

export const cleanQueryParams = (queryParams) => {
  for (var key in queryParams) {
    if (key !== 'tag' || !queryParams[key]) {
      delete queryParams[key]
    }
  }
  return queryParams
}

export const isEmptyObject = (obj) => {
  return !Object.keys(obj).length && obj.constructor === Object
}
